import { render, staticRenderFns } from "./frozenCardList.vue?vue&type=template&id=a905f828&scoped=true"
import script from "./frozenCardList.vue?vue&type=script&lang=js"
export * from "./frozenCardList.vue?vue&type=script&lang=js"
import style0 from "./frozenCardList.vue?vue&type=style&index=0&id=a905f828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a905f828",
  null
  
)

export default component.exports